import { createTheme } from "@mui/material/styles";

import { components } from "./components";
import { darkPalette, lightPalette } from "./palette";
import { dark, DESKTOP_BREAKPOINT, light, RADIUS } from "./tokens";
import { typography } from "./typography";

/**
 * The single app theme. CSS variables plus `colorSchemes` give SSR-safe, flash-free
 * light/dark switching driven by `useColorScheme()`.
 *
 * `--elyxeer-page-gradient` is declared per scheme so `MuiCssBaseline` can paint the
 * brand's Science Silver backdrop without knowing which scheme is active.
 */
export const theme = createTheme({
  cssVariables: { colorSchemeSelector: "class" },
  // Bind MUI's `md` to the token. Without this the `sx` breakpoints used across the app
  // and the media queries baked into the type scale would be two independent 900s that
  // could silently drift apart.
  breakpoints: {
    values: { xs: 0, sm: 600, md: DESKTOP_BREAKPOINT, lg: 1200, xl: 1536 },
  },
  colorSchemes: {
    light: { palette: lightPalette },
    dark: { palette: darkPalette },
  },
  shape: { borderRadius: RADIUS.md },
  typography,
  components: {
    ...components,
    MuiCssBaseline: {
      ...components?.MuiCssBaseline,
      styleOverrides: {
        ...(components?.MuiCssBaseline?.styleOverrides as object),
        ":root": { "--elyxeer-page-gradient": light.gradient },
        ':root[data-mui-color-scheme="dark"], .dark': {
          "--elyxeer-page-gradient": dark.gradient,
        },
      },
    },
  },
});
